import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[qtColumnDef]',
  standalone: false,
})
export class ColumnDefDirective {
  @Input('qtColumnDef') id: string;

  template = this.templateRef;

  constructor(private templateRef: TemplateRef<any>) {}
}
